<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-medkit"></i> Micorloan Helpdesk</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm" routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>
            <!--end header-->
        

            <div class="row row-replace m-t-30">
                <div class="col-md-6">
                    <img src="assets/img/Smiley.png" class="img-fluid">
                    <h3>Congratulations! You are eligible for micro loan. We have received your application you will be reverted in 15 days.</h3>
               </div>
               <div class="col-md-6">
                <img src="assets/img/micro-loan-banner.jpg" class="img-fluid">
              </div>
            </div>

             <!-- <div class="row m-t-30">
                 <div class="col-12">
                        <div class="table-responsive">
                            <table class="table">
                                <tr class="bg-primary text-white">
                                    <th width="100">Sr No.</th>
                                    <th>Title</th>
                                    <th width="150">Download PDF</th>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Cashless Process</td>
                                    <td>Download PDF</td>
                                </tr>
                            </table>
                         </div>
                    </div>
             </div> -->
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

